import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { PostBadge } from "./PostBadge";
import { featuredPost } from "../data/blog";
import { IMAGES } from "../data/content";
import { responsive } from "../lib/img";

export default function BlogTeaser() {
  const p = featuredPost;
  const royal = p.theme === "royal";
  return (
    <section className="mx-auto max-w-7xl px-5 md:px-10 py-24" data-testid="home-blog-teaser">
      <Reveal>
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
          <div>
            <Overline className="text-gold">Blog Articles</Overline>
            <h2 className="mt-4 font-heading font-black text-3xl md:text-5xl tracking-tight">
              COURT KNOWLEDGE. <span className="gold-text">SHARED.</span>
            </h2>
          </div>
          <Link to="/blog-articles" data-testid="home-blog-all" className="inline-flex items-center gap-1.5 font-bold text-gold hover:text-gold-hover">
            All articles <ArrowUpRight size={17} />
          </Link>
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <Link to={`/blog-articles/${p.slug}`} data-testid="home-blog-feature"
              className={`group grid md:grid-cols-[1.15fr_1fr] overflow-hidden rounded-lg border bg-obsidian-800 transition-colors ${
                royal ? "border-royal/40 hover:border-royal-light shadow-[0_0_70px_rgba(31,79,216,0.16)]" : "border-white/10 hover:border-gold/40"
              }`}>
          <div className="relative overflow-hidden">
            <img {...responsive(IMAGES[p.hero], "(min-width: 768px) 55vw, 100vw", [480, 800, 1200])} loading="lazy" decoding="async" alt={p.title}
                 className="h-[240px] md:h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
            <PostBadge post={p} className="absolute left-5 top-5" />
          </div>
          <div className="p-7 md:p-10 flex flex-col justify-center">
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">{p.dateLabel} · {p.readTime}</span>
            <h3 className="mt-4 font-heading font-black text-xl md:text-2xl leading-tight tracking-tight group-hover:text-neon transition-colors">
              {p.title}
            </h3>
            <p className="mt-4 text-sm md:text-base text-zinc-300">{p.dek}</p>
            <span className="mt-6 inline-flex items-center gap-2 font-bold text-gold">
              Read the article
              <ArrowUpRight size={17} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </span>
          </div>
        </Link>
      </Reveal>
    </section>
  );
}
